import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';

const Login = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-lg md:rounded-xl shadow-elevation-lg p-6 md:p-8 lg:p-10">
          <LoginHeader />
          <LoginForm />
          <LoginFooter />
        </div>

        <div className="mt-6 md:mt-8 text-center">
          <p className="text-xs md:text-sm text-muted-foreground">
            &copy; {new Date()?.getFullYear()} CatalogFlip. {t('embedSettings.footer.rights')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;